import { z } from 'zod';
const shiftParticipationSchema = z.object({
    participationId: z.string().uuid(),
    participantId: z.string().uuid(),
});
const denyVolunteersCommonParamsSchema = z.object({
    shiftId: z.string().uuid(),
    missionTypeId: z.string().uuid(),
    status: z.enum(['deniedNotQualified', 'deniedRosterFull']),
});
const denyVolunteerPlatformFunctionParamsSchema = denyVolunteersCommonParamsSchema.merge(shiftParticipationSchema);
export const denyVolunteerFunctionDef = {
    name: 'denyVolunteer',
    requestSchema: denyVolunteerPlatformFunctionParamsSchema,
    responseSchema: z.void(),
};
const handleDenyParamsSchema = z
    .object({
    missionId: z.string().uuid(),
})
    .merge(denyVolunteerPlatformFunctionParamsSchema);
export const denyVolunteersBulkActionType = 'denyVolunteers';
const denyVolunteersBulkActionParamsSchema = denyVolunteersCommonParamsSchema.merge(z.object({
    shiftParticipations: shiftParticipationSchema.array(),
}));
